import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function LearnisticLogo(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "25.729"}
      height={height || "30"}
      viewBox="0 0 25.729 30"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="0.999"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#1178be" />
          <stop offset="1" stop-color="#25a8e0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="0.181"
          y1="0.681"
          x2="0.822"
          y2="0.044"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stop-color="#f28f16" />
          <stop offset="1" stop-color="#f8a930" />
        </linearGradient>
      </defs>
      <g
        id="Learnistic_logo"
        data-name="Learnistic logo"
        transform="translate(0 0)"
      >
        <g id="Grupo_10756" data-name="Grupo 10756" transform="translate(0 0)">
          <path
            id="Caminho_10309"
            data-name="Caminho 10309"
            d="M11.894-.58a.683.683,0,0,0,.115.075L15.5.852l4.308,1.672,3.334,1.3,1.427.565a.452.452,0,0,1,.156.085l-.212.082L22.9,5.127c-.082.03-.125.066-.1.16a.758.758,0,0,1,0,.174v5.881c0,.156,0,.25.184.323a.742.742,0,0,1,.464.775.833.833,0,0,1-.534.742.786.786,0,0,1-.476.049.887.887,0,0,1-.643-.763.829.829,0,0,1,.577-.869.143.143,0,0,0,.076-.106q0-3,0-6.01v-.2l-.984.348c-.6.214-1.194.429-1.792.641a.134.134,0,0,0-.106.148c0,.395,0,.789-.017,1.186Q19.527,8.8,19.5,9.988a.064.064,0,0,1-.017.037,16.072,16.072,0,0,0-7.534-1.912A15.7,15.7,0,0,0,4.215,9.991a.723.723,0,0,1-.082.04V6.426a.129.129,0,0,0-.106-.144Q1.941,5.531-.145,4.773c-.263-.1-.53-.186-.8-.28-.014,0-.024-.021-.057-.049l.16-.056L3.643,2.631c.791-.309,1.585-.612,2.378-.921C6.939,1.351,7.866.988,8.775.628L11.657-.493a.8.8,0,0,0,.134-.087Z"
            transform="translate(1 0.58)"
            fill="url(#linear-gradient)"
          />
          <path
            id="Caminho_10310"
            data-name="Caminho 10310"
            d="M26.214,59.968c-.037.212-.071.417-.108.624-.115.661-.228,1.319-.348,1.98-.132.756-.268,1.512-.4,2.27-.144.824-.285,1.65-.428,2.474-.052.3-.11.591-.16.887a.174.174,0,0,0,.035.134c.721.718,1.448,1.432,2.2,2.17.174-.189.36-.379.544-.562.522-.509,1.043-1.02,1.565-1.519a.348.348,0,0,0,.106-.348l-.348-2.109c-.111-.7-.214-1.391-.325-2.086-.1-.612-.2-1.217-.294-1.832-.108-.673-.214-1.4-.322-2.086a1.616,1.616,0,0,1,.205,0,19.2,19.2,0,0,1,4.628,1.09c.348.12.675.254,1.008.389a.275.275,0,0,1,.137.136q.735,1.817,1.46,3.651l1.194,2.988c.082.2.085.2-.1.336-.892.668-1.754,1.372-2.575,2.124-.622.572-1.246,1.146-1.838,1.751-.621.635-1.217,1.3-1.8,1.97a21.324,21.324,0,0,0-2.4,3.333c-.309.534-.572,1.1-.855,1.643a.464.464,0,0,1-.045.063c-.09-.174-.174-.348-.259-.522a23.469,23.469,0,0,0-1.782-2.867,32.5,32.5,0,0,0-2.877-3.454,34.049,34.049,0,0,0-2.967-2.764c-.582-.482-1.193-.93-1.789-1.391a.089.089,0,0,1-.028-.078c.125-.294.263-.582.384-.878.348-.829.678-1.66,1.015-2.491.466-1.139.93-2.279,1.4-3.416a.325.325,0,0,1,.143-.151,9.967,9.967,0,0,1,2.26-.887c.615-.158,1.236-.3,1.864-.4a13.121,13.121,0,0,1,1.82-.174.453.453,0,0,1,.071.005Z"
            transform="translate(-14.081 -49.437)"
            fill="url(#linear-gradient-2)"
          />
        </g>
      </g>
    </svg>
  );
}
